
import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { ModalType } from "../../constant";
@Component
export default class ThankYouModal extends Vue {
  @Prop() private topPosition!: number;
  @Prop() private printOptionSelected!: boolean;
  @Emit("closeModal") closeModal(modalName: string) {}
  h3Message = "Thank you!";
  printOptionMessage = "Your printable map is being opened in a new window.";
  dreesMessage =
    "Your request will be reviewed first by our New Home Specialist. They will be in contact shortly to let you know the status of your request. We appreciate your patience.";
  handleClose() {
    this.closeModal(ModalType.THANK_YOU);
  }
}
